/**
 * @author Rahul Nainala
 * @description 
 */
import '../CSS/eLog.css';
import { Row, Col, Tabs } from 'antd';
import { Header, TableView } from '.';
import React, { useState, useEffect, useCallback } from 'react';

const { TabPane } = Tabs;

const SubSectionTableView = (props) => {
  const [form, setForm] = useState(props.form || {});
  const [, setColumns] = useState((props.form && props.form.columns) || []);
  const [, setData] = useState((props.form && props.form.datasource) || []);
  const [, setActiveKey] = useState([]);
  useEffect(() => {
    setForm(props.form);
    setColumns((props.form && props.form.columns) || []);
    setData((props.form && props.form.datasource) || []);
  }, [props.form]);

  const setValue = useCallback((name, e) => {
    setForm(prevForm => {
      let headerValue = {
        ...(prevForm && prevForm[name] && prevForm[name].headerValue),
        [e.key]: e.value
      };

      const updatedForm = {
        ...prevForm,
        [name]: {
          ...(prevForm && prevForm[name] ? prevForm[name] : {}),
          headerValue: {
            ...headerValue
          }
        }
      };

      props.saveSubSectionTableViewData(updatedForm);
      return updatedForm;
    });
  }, [props]);

  const saveTableViewData = useCallback((name, data) => {
    setForm(prevForm => {
      const updatedForm = {
        ...prevForm,
        [name]: {
          ...(prevForm[name] ? prevForm[name] : {}),
          datasource: data
        }
      };

      props.saveSubSectionTableViewData(updatedForm);
      return updatedForm;
    });
  }, [props]);

  const callback = useCallback((key) => {
    setActiveKey(key);
  }, []);

  return (
    <div className="card-container" style={{ marginTop: '30px', marginBottom: '30px' }}>
      <Tabs
        type="card"
        bordered={true}
        onChange={callback}
      >
        {form &&
          Object.keys(form).map((name) => {
            if (name !== 'batch') {
              return (
                <TabPane tab={name} key={name}>
                  <Row>
                    <Col span={16}>
                      <Header
                        header={form[name].header}
                        headerValue={form[name].headerValue}
                        recordType={props.recordType}
                        setValue={(e) => setValue(name, e)}
                        form={form}
                        sectioName={name}
                        status={props.status}
                      />
                    </Col>
                  </Row>
                  <TableView
                    form={form[name]}
                    loading={props.loading}
                    recordType={props.recordType}
                    saveTableViewData={(e) => saveTableViewData(name, e)}
                  />
                </TabPane>
              );
            }
            return null;
          })}
      </Tabs>
    </div>
  );
};

export default SubSectionTableView;
